module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"item_import_title":"Fragen importieren","save":"Speichern","cancel":"Abbrechen"},"en":{"item_import_title":"Import Items","save":"Save","cancel":"Cancel"}}')
  delete Component.options._Ctor
}
